import React from 'react';
import loc from 'owa-localize';
import { observer } from 'owa-mobx-react';
import { KeytipManager, type IKeytipLayerProps } from '@fluentui/react';
import { KeytipLayer } from '@fluentui/react/lib/KeytipLayer';
import { isHostAppFeatureEnabled } from 'owa-hostapp-feature-flags';
import { keytipAriaDescription } from './RibbonKeytipLayer.locstring.json';
import { useValueInitializedOnce } from 'owa-react-hooks/lib/useValueInitializedOnce';
import { useCustomKeytipEvents } from './useCustomKeytipEvents';
import { onEnterKeytipMode, onExitKeytipMode } from 'owa-command-ribbon-keytip-utils';

const getContent = (): IKeytipLayerProps['content'] => {
    return isHostAppFeatureEnabled('altForKeytips')
        ? loc(keytipAriaDescription, 'Alt', 'F10')
        : 'Alt';
};

export interface RibbonKeytipLayerProps {
    selectedTabId: string;
}

export const RibbonKeytipLayer: React.FunctionComponent<RibbonKeytipLayerProps> = observer(
    ({ selectedTabId }: RibbonKeytipLayerProps) => {
        useValueInitializedOnce(() => {
            // Delay registration of keytips until user is in keytip mode
            KeytipManager.getInstance().init(true);
        });

        useCustomKeytipEvents(isHostAppFeatureEnabled('altForKeytips'));

        return (
            <KeytipLayer
                content={getContent()}
                onEnterKeytipMode={onEnterKeytipMode(selectedTabId)}
                onExitKeytipMode={onExitKeytipMode}
            />
        );
    },
    'RibbonKeytipLayer'
);
